import { getSignUpDataAPIConfig } from '../../../shared/api-configs/profile';
import { LOAD_STATE } from '../../../shared/axios';
import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { LoadState } from './update-sign-up-data/update-sign-up-data.types';
import { CheckSignUpData } from './check-sign-up-data.types';

export const CHECK_SIGN_UP_DATA_REQUEST_CALLED = '@auth/CHECK_SIGN_UP_DATA_REQUEST_CALLED';
export const CHECK_SIGN_UP_DATA_REQUEST_SUCCEEDED = '@auth/CHECK_SIGN_UP_DATA_REQUEST_SUCCEEDED';
export const CHECK_SIGN_UP_DATA_REQUEST_FAILED = '@auth/CHECK_SIGN_UP_DATA_REQUEST_FAILED';
export const USER_PROFILE_SIGN_UP_DATA_SUBMITTED = '@auth/USER_PROFILE_SIGN_UP_DATA_SUBMITTED';
export const SET_IS_USER_PROFILE_COMPLETE = '@auth/SET_IS_USER_PROFILE_COMPLETE';
export const SET_IS_COMPANY_COMPLETE = '@auth/SET_IS_COMPANY_COMPLETE';
export const SET_IS_SIGN_UP_DATA_COMPLETE = '@auth/SET_IS_SIGN_UP_DATA_COMPLETE';

export type State = {
    data: CheckSignUpData,
    isSignUpDataComplete: boolean,
    loadState: LoadState,
    error: Object,
}

export const getUserProfileSignUpData = state => state.auth.checkSignUpData.data.userProfile;
export const getTeamSignUpData = state => state.auth.checkSignUpData.data.team;
export const isUserProfileSignUpDataComplete = state => state.auth.checkSignUpData.data
    .isUserProfileSignUpDataComplete;
export const isCompanySignUpDataComplete = state => state.auth.checkSignUpData.data
    .isTeamSignUpDataComplete;
export const isUserProfileTeamAdmin = state => state.auth.checkSignUpData.data
    .isUserProfileTeamAdmin;
export const isSignUpDataComplete = state => state.auth.checkSignUpData.isSignUpDataComplete;

export const requestCheckSignUpData = () => ({
    type: CHECK_SIGN_UP_DATA_REQUEST_CALLED,
    actionTypes: {
        success: CHECK_SIGN_UP_DATA_REQUEST_SUCCEEDED,
        fail: CHECK_SIGN_UP_DATA_REQUEST_FAILED,
    },
    config: getSignUpDataAPIConfig(),
});

export const setIsUserProfileSignUpDataComplete = ({ isComplete }) => ({
    type: SET_IS_USER_PROFILE_COMPLETE,
    payload: isComplete,
});

export const setIsCompanySignUpDataComplete = ({ isComplete }) => ({
    type: SET_IS_COMPANY_COMPLETE,
    payload: isComplete,
});

export const setIsSignUpDataComplete = ({ isComplete }) => ({
    type: SET_IS_SIGN_UP_DATA_COMPLETE,
    payload: isComplete,
});

export const initialState: State = {
    data: {
        userProfile: null,
        team: null,
        isUserProfileSignUpDataComplete: false,
        isTeamSignUpDataComplete: false,
        isUserProfileTeamAdmin: false,
    },
    isSignUpDataComplete: false,
    loadState: LOAD_STATE.LOADING,
    error: null,
};

export const checkSignUpDataReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [CHECK_SIGN_UP_DATA_REQUEST_CALLED]: state => ({
        ...state,
        data: {},
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [CHECK_SIGN_UP_DATA_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        data: {
            ...action.payload.data,
            userProfile: {
                // eslint-disable-next-line camelcase
                fullName: action.payload.data.userProfile?.full_name,
                phone: action.payload.data.userProfile?.phone,
            },
        },
        loadState: LOAD_STATE.SUCCESS,
        error: null,
    }),
    [CHECK_SIGN_UP_DATA_REQUEST_FAILED]: (state, action) => ({
        ...state,
        data: {},
        loadState: LOAD_STATE.FAIL,
        error: action.payload.data,
    }),
    [SET_IS_USER_PROFILE_COMPLETE]: (state, action) => ({
        ...state,
        data: {
            ...state.data,
            isUserProfileSignUpDataComplete: action.payload,
        },
    }),
    [SET_IS_COMPANY_COMPLETE]: (state, action) => ({
        ...state,
        data: {
            ...state.data,
            isTeamSignUpDataComplete: action.payload,
        },
    }),
    [SET_IS_SIGN_UP_DATA_COMPLETE]: (state, action) => ({
        ...state,
        isSignUpDataComplete: action.payload,
    }),
});
